import React, { useState, useEffect ,useContext} from "react";

import * as Yup from "yup";
import "./PublishPanel.scss";
import {
  Table,
  Button,
  Space,
  Select,
  DatePicker,
  TimePicker,
  Tabs,
  Tag,
  Card,Tooltip,
  Modal, Switch,
} from "antd";
import {getRole} from '../../Helpers/utils'
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import Axios from "../../Helpers/Interceptors";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import { UserInfo } from "../../Context/userInfo";
const formatDateUS = (date) => {
  return new Date(date).toLocaleDateString("en-US");
};

export default function PublishPanel() {


  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setloading] = useState(false);
  const [UploadID, setUploadID] = useState({});
  const [openFileModal, setopenOpenFileModal] = useState(false);
  const [fileType, setFileType] = useState(null);
  const [roles,setRoles]=useState(null)
  const [type,setType]=useState(false)
  const [modalType,setModalType]=useState('view')
  const [alertType,setAlertType]=useState(null)
  const [filters, setFilters] = useState({
    searchKey: "",
  });
  const { userData, updateUserData } = useContext(UserInfo);
  const [initialValues, setInitialValues] = useState({
    title: "",
    description: "",
    area: "",
  });
  const [userToToggle, setUserToToggle] = useState(null); //
  const [confirmModalOpen, setConfirmModalOpen] = useState(false); // State to manage confirmation modal visibility
  const { Option } = Select;
  const navigate = useNavigate();
  const [list, setlist] = useState([]);
  const [list1, setlist1] = useState([]);

  const [pagination, setPagination] = useState({
    page: 1,
    size: 10,
    total: 0, // You’ll get the total count of records from your API response
  });
  const [file, setFile] = useState(null);
  const [file1, setFile1] = useState(null);
  const MAX_FILE_SIZE = 10 * 1024 * 1024;
  const handleChange = (value) => {
    console.log("Selected:", value);
  };
  const showModal = (data) => {
    setFile1(data.image);
    setSelectedRow(data);
    setInitialValues(data);
    setopenOpenFileModal(true);
  };

  const handleToggle = (record) => {

    setUserToToggle(record); // Set the user whose status we're toggling
    setConfirmModalOpen(true); // Open the confirmation modal
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Role is required *"),
    description: Yup.string().required("Role is required *"),
    area: Yup.string().required("Role is required *"),
  });


  const confirmToggle = async () => {
    try {

      if (selectedRow?.id) {
        const obj = {
          isApproved : type

        };
      const  response = await Axios.put(
          `https://demo.tscti.com/api/alerts/${selectedRow.id}`,
          obj
        );
        if (response.status == 200) {
          // Checks if status code is 200 (OK)

          toast.success("Status change successfully");

          setSelectedRow(null);
          setopenOpenFileModal(false);
          setConfirmModalOpen(false);
          fetchData();
        }
      }


    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }

  };


  const publish = async () => {
    try {

      if (selectedRow?.id) {
        const obj = {

        };
      const  response = await Axios.post(
          `https://demo.tscti.com/api/alerts/publish/${selectedRow?.id}`,
          obj
        );
        if (response.status == 200) {
          // Checks if status code is 200 (OK)

          toast.success("Publish successfully");

          setSelectedRow(null);
          setopenOpenFileModal(false);
          setConfirmModalOpen(false);
          fetchData();
        }
      }


    } catch (err) {
      toast.error(err.message);
      console.log(err.message);
    } finally {
      console.log(false);
    }

  };

  const cancelToggle = () => {
    // setUserToToggle(null);
    setConfirmModalOpen(false);
    // getUser(userData?.id); // Close the confirmation modal without any changes
  };


  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (record) => formatDateUS(record),
    },


    {
      title: "Action",
      dataIndex: "action",
      key: "address",
      align: "center",
      render: (_, record) => (
        <div>
          <i
            className="bx bx-edit"
            style={{ fontSize: "20px" }}
            onClick={() => {
              setModalType('edit')
              showModal(record);
            }}
          ></i>
           <i
  className="bx bx-show"
  style={{ fontSize: "20px"}} // optional styles
  title="View"
  onClick={() => {
    setModalType('view');
    showModal(record);
  }}
></i>
        {(roles === 'Admin' && !record.isApproved && !record.isPublished  ) && (
          <span className="action-buttons" style={{marginLeft:'5%'}}>
            <Tooltip title={"Accept"}>
              <button
                className="btn btn-success"
                onClick={() => {handleToggle(record);setType(true);setSelectedRow(record);setAlertType('approve')}}
              >
                Accept
              </button>
            </Tooltip>
            <Tooltip title={"Reject"} >
              <button style={{marginLeft:'5%'}}
                className="btn btn-danger"
                onClick={() => {handleToggle(record);setType(false);setSelectedRow(record);setAlertType('approve')}}
              >
                Reject
              </button>
            </Tooltip>
          </span>
        )}

{( record.isApproved && !record.isPublished) && (
          <span className="action-buttons" style={{marginLeft:'5%'}}>
            <Tooltip title={"Publish"}>
              <button
                className="btn btn-success"
                onClick={() => {handleToggle(record);setSelectedRow(record);setAlertType('publish')}}
              >
                Publish
              </button>
            </Tooltip>

          </span>
        )}
        </div>
      ),
    },
  ];
  useEffect(() => {
    if(userData){
        setRoles( getRole(userData.data?.userInfo?.roles))
      }
    fetchData(pagination.page, pagination.size);
  }, [userData]);

  const closeFileToggle = () => {
    setFile(null);
    setopenOpenFileModal(false);
  };

  const handleRemoveFile = () => {
    setFile(null); // Clear the file from the state
  };
  const handlePaginationChange = (page, pagesize) => {
    console.log("asd", page, pagesize);
    setPagination((prev) => ({ ...prev, page: page, size: pagesize }));
    fetchData(page, pagesize);
  };

  const fetchData = async (page, size) => {
    const obj = {
      page: page,
      size: size,
    };
    try {
      const response = await Axios.get(
        `https://demo.tscti.com/api/alerts`
      );

      setlist(response.data);
      setlist1(response.data);
      //   setPagination((prop) => ({
      //     ...prop,
      //     total: response.data.totalElements || 0, // Set total from the response
      //   }));
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        toast.error("File size exceeds the 10MB limit.");
        setFile(null); // Clear the file selection
      } else {
        setFile(file);
        uploadFile(file);
      }
    }
  };

  const uploadFile = async (file) => {
    const base64 = await convertToBase64(file);
    const pureBase64 = base64.split(",")[1];

    const obj = {
      fileName: file.name || "StreetMaintainenacne.jpeg", // dynamically use file name if needed
      contentType: file.type || "image/png",
      file: pureBase64, // ✅ NO extra quotes
    };

    try {
      const response = await Axios.post(
        `https://demo.tscti.com/api/files/upload/testing`,
        obj
      );
      console.log(response.data);
      setFile1(response.data);
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result); // Base64 string here
      reader.onerror = (error) => reject(error);
    });
  };

  const submit = async (value, reset) => {
    try {
      let response;
      if (selectedRow?.id) {
        const obj = {
          image: file1, // dynamically use file name if needed
          title: value.title,
          description: value.description, // ✅ NO extra quotes
          area: value.area,
        };
        response = await Axios.put(
          `https://demo.tscti.com/api/alerts/${selectedRow.id}`,
          obj
        );
      } else {
        const obj = {
          image: file1, // dynamically use file name if needed
          title: value.title,
          description: value.description, // ✅ NO extra quotes
          area: value.area,
        };
        response = await Axios.post(
          "https://demo.tscti.com/api/alerts",
          obj
        );
      }

      if (response.status == 200) {
        // Checks if status code is 200 (OK)

        toast.success("Status change successfully");
        reset();
        setSelectedRow(null);
        setopenOpenFileModal(false);
        fetchData();
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      console.log(false);
    }
  };

 const  handleSearch =()=>{
  const lowerQuery = searchQuery.toLowerCase();
    const filtered = list1.filter((item) =>
      Object.values(item).some(
        (val) =>
          val &&
          val.toString().toLowerCase().includes(lowerQuery)
      )
    );
    setlist(filtered)
 }


  return (
    <>
      {loading && <Loader />}
      <div
        className="signup-content2 "
        style={{
          paddingLeft: "2%",
          paddingRight: "2%",
          paddingTop: "1%",
          height: "100vh",
        }}
      >
        {/* <div
          className="card  mb-3  p-3"
          style={{
            background: "rgb(130 195 65 / 69%)",
            textAlign: "left",
          }}
        >
          <h5 style={{ color: "whitesmoke", marginBottom: "0px" }}>
            {" "}
            Central Alert Publishing Panel{" "}
          </h5>
        </div> */}

        <div className="bg-gradient p-2 rounded filter">
          <div className="row">
            <div className="col-md-4 col-lg-4">
              <label className="label-heading1">Search</label>
              <input
  className="form-input"
  name="Search"
  id="Search"
  placeholder="Search*"
  autoComplete="new-password"
  value={searchQuery}
  onChange={(e) => setSearchQuery(e.target.value)}
/>

            </div>

            <div className="col-md-3 col-lg-3">
              <div className="filter-button">
                <button
                  className="btn btn-style btn-save"
                  style={{
                    background: "rgb(130 195 65 / 69%)",
                    color: "whitesmoke",
                  }}
                  onClick={handleSearch}
                >
                  <i
                    className="fas fa-search"
                    style={{ marginRight: "8px" }}
                  ></i>{" "}
                  Search
                </button>

                <button
                  className="btn btn-style btn-cancel"
                  style={{ background: "#F44336", color: "whitesmoke" }}
                  onClick={() => {setlist(list1);setSearchQuery('')}}
                >
                  <i
                    className="fas fa-times"
                    style={{ marginRight: "8px" }}
                  ></i>{" "}
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="add-button mt-2">
          <Button
            type="primary"
            className="add-user-btn"
            style={{ padding: "18px" }}
            onClick={() => {

              setModalType('add')
              setopenOpenFileModal(true);
              setSelectedRow(null);
              setFile(null);
              setFile1(null)
              setInitialValues({
                title: "",
                description: "",
                area: "",
              })
            }}
          >
            <i className="bx bx-plus"></i> Add Alert
          </Button>
        </div>
        <div
          className="bg-gradient p-2 rounded mt-2"
          style={{ position: "relative" }}
        >
          <Table
            dataSource={list}
            columns={columns}
            scroll={{ y: 350 }}
            rowClassName={() => "custom-row"}
            // pagination={{
            //   showSizeChanger: true,
            //   onChange: handlePaginationChange,

            //   current: pagination.page,
            //   pageSize: pagination.size,

            //   total: pagination.total,

            //   showTotal: (total, range) => (
            //     <span style={{ color: "whitesmoke" }}>
            //       Total {total} records, showing {range[0]} to {range[1]}
            //     </span>
            //   ),
            // }}
          />
          {/* <div
          className="table-header"
          style={{
            background: "rgb(5, 162, 179)",
          }}
        >
          <h4 style={{ fontFamily: "Myriad Pro" }}>Agent Care Tickets</h4>
        </div> */}
          ;
        </div>
      </div>

      <Modal
        open={openFileModal}
        onCancel={closeFileToggle}
        footer={null}
        maskClosable={false}
        destroyOnClose={true}
      >
        <div className="signup-content-model1">
          <div className="heading-content">
            <h2>{fileType}</h2>
          </div>

          <div className="upload-container">

            <div
          className="card  mb-3  p-2"
          style={{
            background: "rgb(78 155 1 / 69%)",
            textAlign: "left",
          }}
        >
          <h5 style={{ color: "whitesmoke", marginBottom: "0px" }}>
            {" "}
            Add Publishing Alertl{" "}
          </h5>
        </div>
        <Formik
              validationSchema={validationSchema}
              enableReinitialize={true}
              initialValues={initialValues}
              onSubmit={(values, { resetForm }) => {
                submit(values, resetForm); // Use your custom submit logic here
              }}
            >
              {({ errors, touched, setFieldValue }) => (
                <Form id="signup-form" className="signup-form">
                  <div className="row">
                    <div className="col-md-6 col-lg-6">
                      <label className="label-heading1">Title</label>
                      <Field
                        className={`form-input1 ${
                          errors.title && touched.title ? "error" : ""
                        }`}
                        name="title"
                        placeholder="Title*"
                        autoComplete="new-password"
                      />
                    </div>

                    <div className="col-md-6 col-lg-6">
                      <label className="label-heading1">Area</label>
                      <Field
                        className={`form-input1 ${
                          errors.area && touched.area ? "error" : ""
                        }`}
                        name="area"
                        placeholder="Area*"
                        autoComplete="new-password"
                      />
                    </div>

                    <div className="col-md-12 col-lg-12">
                      <label className="label-heading1">Description</label>
                      <Field
                        as="textarea"
                        className={`form-input1 ${
                          errors.description && touched.description
                            ? "error"
                            : ""
                        }`}
                        name="description"
                        placeholder="Description*"
                        autoComplete="new-password"
                        rows="4"
                        cols="12"
                      />
                    </div>
                  </div>
                  {!file1 ? (
              <div
                className="upload-box mt-2"
                onClick={() => document.getElementById("fileInput").click()}
              >
                <i className="fa fa-cloud-upload-alt"></i>
                <p>Click To Upload</p>
                <input
                  type="file"
                  id="fileInput"
                  hidden
                  onChange={handleFileChange}
                  multiple
                  accept=".jpeg,.jpg,.png"
                />
              </div>
            ) : (
              <div className="image-preview  mt-2">
                <img
                  src={file1}
                  alt="Uploaded"
                  style={{
                    width: "200px", // Fixed width
                    height: "200px", // Fixed height
                    objectFit: "cover", // Keeps image from stretching
                    borderRadius: "8px", // Optional: rounded corners
                  }}
                />
                <div>

                {modalType !="view" &&  <button
                    className="remove-btn"
                    onClick={() => {
                      setFile1(null);
                      setFile(null);
                    }}
                  >
                    Remove
                  </button>}
                </div>
              </div>
            )}
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <small style={{ color: "gray" }}>
                Supported file formats: .jpeg, .jpg, .png
              </small>
            </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                    }}
                  >




{modalType !="view" &&   <div
                      className="submit-container1"
                      style={{ marginTop: "20px" }}
                    >
                      <button className="submit-button1" type="submit">
                        Save
                      </button>
                      <button
                        className="submit-button2"
                        type="button"
                        onClick={closeFileToggle}
                      >
                        Close
                      </button>
                    </div> }
                  </div>
                </Form>
              )}
            </Formik>





          </div>
        </div>
      </Modal>



      <Modal
          open={confirmModalOpen}
          onCancel={cancelToggle}
          destroyOnClose={true}
          footer={null}
          maskClosable={false}
        >
          <div className="signup-content-model1">
            <p>
             {alertType == 'approve' ? ' Are you sure you want to change the approval status ?' :  ' Are you sure you want to Publish this Alert ?'}
            </p>
            <div className="submit-container1" style={{ marginTop: "20px" }}>
              <button
                className="submit-button1 "
                type="submit"
                onClick={alertType == 'approve' ? confirmToggle : publish}
              >
                Yes
              </button>
              <button
                className="submit-button2"
                type="button"
                onClick={() => cancelToggle()}
              >
                No
              </button>
            </div>
          </div>
        </Modal>
    </>
  );
}
